import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import client from 'services/networking/client';

var UserMenu = function UserMenu() {
  var intl = useIntl();
  var logout = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.logout();

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  return __jsx("div", null, __jsx(IconButton, {
    "aria-label": intl.formatMessage({
      id: 'header.logout'
    }),
    title: intl.formatMessage({
      id: 'header.logout'
    }),
    onClick: logout
  }, __jsx(ExitToAppIcon, null)));
};

export default UserMenu;